import isEmptyNumber from 'utils/phone/isEmptyNumber';
import isValidPhoneNumber from 'utils/phone/isValidPhoneNumber';
const showPhoneNumberError = phoneNr => {
  return !isEmptyNumber(phoneNr) && !isValidPhoneNumber(phoneNr);
};
export default showPhoneNumberError;